import {randomNum} from '../../../helpers';

export default {
    data() {
        return {
            terms: [],
            selectedTerms: [],
            termList: terms,
            termFlatList: termsFlat,
            selectedPlan: null,
            scoreChartOptions: {
                maintainAspectRatio: false,
                responsive: true,
                legend: false,
                tooltips: false,
                // tooltips: {
                //     // mode: 'index',
                //     // intersect: false,
                // },
                // hover: {
                //     mode: 'nearest',
                //     intersect: true,
                // },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            max: 30,
                            precision: 0,
                            fontColor: '#263c61',
                            fontSize: 10,
                        },
                    }],
                    yAxes: [{
                        // display: false,
                        ticks: {
                            beginAtZero: true,
                            precision: 0,
                            fontColor: '#263c61',
                            align: 'start',
                            fontSize: 11,
                            fontWeight: 'bold',
                        },
                    }],
                },
            },
        };
    },
    computed: {
        plans() {
            return plans[this.companyType];
        },
        upgradePlanMessage() {
            const plan = __(`forms.options.plans.${this.nextPlanName}`);

            return __('info.message.upgrade_plan', {plan});
        },
        nextPlanName() {
            return this.selectedPlan.name === 'bronze' ? 'silver' : 'gold';
        },
        termPrices() {
            return termPrices[this.companyType][this.selectedPlan.name];
        },
        currentPrice() {
            let additionalPrice = 0;
            if (this.selectedPlan && (this.selectedPlan.name !== 'gold')
                && (this.selectedPlan.points < this.selectedTermsScore)) {
                _.forEach(this.termPrices, (price, term) => {
                    if (this.selectedTerms.includes(term)) {
                        additionalPrice += price;
                    }
                });
            }

            return this.selectedPlan.price + additionalPrice;
        },
        termToSuggest() {
            if (!this.selectedPlan) {
                return null;
            }
            return _.find(termsToSuggest[this.selectedPlan.name], (termSlug) => {
                const term = _.find(this.termFlatList, {slug: termSlug});
                return (!this.selectedTerms.includes(termSlug) &&
                    ((term.score <= this.availablePoints) && (this.termPrices[termSlug] === 0) ||
                        ((term.score >= this.availablePoints) && (this.termPrices[termSlug] > 0))));
            });
        },
        suggestTermText() {
            if (!this.termToSuggest) {
                return null;
            }
            const price = this.termPrices[this.termToSuggest];

            if (price === 0) {
                const percent = randomNum(88, 96);
                return __('info.message.customers_choose_term', {percent});
            } else {
                return __('info.message.get_term_for_money', {price});
            }
        },
        selectedTermsScore() {
            return _.sum(this.terms.map(term => term.score + this.subTermScore(term)));
        },
        availablePoints() {
            if (!this.selectedPlan.points) {
                return null;
            }

            const points = this.selectedPlan.points - this.selectedTermsScore;

            return (points > 0) ? points : 0;
        },
        scoresChartData() {
            const scores = {
                tax_optimization: 0,
                finance: 0,
                strategy: 0,
                stability: 0,
                risk_minimization: 0,
            };

            this.terms.forEach((term) => {
                scores.tax_optimization += term.tax_optimization;
                scores.finance += term.finance;
                scores.strategy += term.strategy;
                scores.stability += term.stability;
                scores.risk_minimization += term.risk_minimization;

                if (term.sub_terms.length) {
                    term.sub_terms.forEach((subTerm) => {
                        if (subTerm.selected) {
                            scores.tax_optimization += subTerm.tax_optimization;
                            scores.finance += subTerm.finance;
                            scores.strategy += subTerm.strategy;
                            scores.stability += subTerm.stability;
                            scores.risk_minimization += subTerm.risk_minimization;
                        }
                    });
                }
            });

            return {
                labels: [
                    __('forms.options.scores.tax_optimization'),
                    __('forms.options.scores.finance'),
                    __('forms.options.scores.strategy'),
                    __('forms.options.scores.stability'),
                    __('forms.options.scores.risk_minimization'),
                ],
                datasets: [
                    {
                        backgroundColor: 'rgba(38, 60, 97, 0.8)',
                        borderColor: 'rgb(38, 60, 97)',
                        data: Object.values(scores),
                    },
                ],
            };
        },
    },
    created() {
        this.setDefaultPlan();
        this.$nextTick(() => {
            this.setMandatoryTerms();
        });
    },
    watch: {
        currentStep(step) {
            if (step === 7) {
                this.$nextTick(() => {
                    $(`#term-${this.termToSuggest}`).tooltip();
                });
            }
        },
        termToSuggest(newTerm, oldTerm) {
            this.$nextTick(() => {
                if (oldTerm) {
                    $(`#term-${oldTerm}`).tooltip('dispose');
                }
                if (newTerm) {
                    $(`#term-${newTerm}`).tooltip();
                }
            });
        },
        'company.privileged': function () {
            this.setDefaultPlan();
        },
    },
    methods: {
        setDefaultPlan() {
            let plan = this.selectedPlan ? this.selectedPlan.name : 'bronze';
            let url = new URL(window.location.href);
            const newPlan = url.searchParams.get('plan');

            if (newPlan) {
                plan = newPlan;
                window.history.replaceState({}, document.title, `${url.origin}${url.pathname}`);
            }

            this.selectedPlan = this.plans[plan];
        },
        changePlan(plan) {
            if ((this.selectedPlan.name === 'silver' && plan.name === 'bronze') ||
                this.selectedPlan.name === 'gold') {
                this.$refs.downgradePlanModal.open(() => {
                    this.selectedPlan = plan;
                    this.$nextTick(() => {
                        this.setMandatoryTerms();
                    });
                })
            } else {
                this.selectedPlan = plan;
                this.$nextTick(() => {
                    this.setMandatoryTerms();
                });
            }
        },
        upgradePlan() {
            this.selectedPlan = this.plans[this.nextPlanName];
            this.$nextTick(() => {
                this.setMandatoryTerms();
            });
        },
        setSelectedTerms() {
            this.terms = [];

            this.termList.forEach((term) => {
                if (this.selectedTerms.includes(term.slug)) {
                    if (term.sub_terms.length) {
                        term.sub_terms.forEach((subTerm) => {
                            subTerm.selected = this.selectedTerms.includes(subTerm.slug);
                        });
                    }
                    this.terms.push(term);
                }
            });
        },
        jumpToSuggestedTerm() {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(`#term-${this.termToSuggest}`).offset().top - 390,
            }, 500);
        },
        updateTermIds() {
            const selectedTerms = [];
            this.terms.forEach((term) => {
                selectedTerms.push(term.slug);
                if (term.sub_terms.length) {
                    term.sub_terms.forEach((subTerm) => {
                        if (subTerm.selected) {
                            selectedTerms.push(subTerm.slug);
                        }
                    });
                }
            });

            this.selectedTerms = selectedTerms;
        },
        updateMandatoryTermIds() {
            const selectedTerms = [];
            this.terms.forEach((term) => {
                selectedTerms.push(term.slug);
                if (term.sub_terms.length) {
                    term.sub_terms.forEach((subTerm) => {
                        subTerm.selected = false;
                        switch (this.selectedPlan.name) {
                            case 'bronze':
                                if (subTerm.status === 'bronze') {
                                    selectedTerms.push(subTerm.slug);
                                    subTerm.selected = true;
                                }
                                break;
                            case 'silver':
                                if (subTerm.status !== 'gold' && (!subTerm.is_radio || (subTerm.is_radio && subTerm.status === 'silver'))) {
                                    selectedTerms.push(subTerm.slug);
                                    subTerm.selected = true;
                                }
                                break;
                            case 'gold':
                                if (!subTerm.is_radio || (subTerm.is_radio && subTerm.status === 'silver')) {
                                    selectedTerms.push(subTerm.slug);
                                    subTerm.selected = true;
                                }
                                break;
                            default:
                                break;
                        }
                    });
                }
            });

            this.selectedTerms = selectedTerms;
        },
        termSelected(slug) {
            return this.selectedTerms.includes(slug);
        },
        setMandatoryTerms() {
            switch (this.selectedPlan.name) {
                case 'bronze':
                    this.terms = this.termList.filter(term => term.status === 'bronze');
                    break;
                case 'silver':
                    this.terms = this.termList.filter(term => term.status !== 'gold');
                    break;
                case 'gold':
                    this.terms = Object.assign([], this.termList);
                    break;
                default:
                    break;
            }

            this.updateMandatoryTermIds();
        },
        subTermScore(term) {
            return _.sum(term.sub_terms.map(subTerm => subTerm.selected ? subTerm.score : 0));
        },
        toggleTerm(term) {
            if (this.termSelected(term.slug)) {
                this.terms = _.remove(this.terms, (item) => item.slug !== term.slug);
            } else {
                if ((this.selectedPlan.name === 'gold') || (term.score <= this.availablePoints) || term.slug === this.termToSuggest) {
                    this.terms.push(term);
                } else {
                    this.$refs.upgradePlanModal.open(() => {
                        this.upgradePlan();
                    });
                }
            }

            this.updateTermIds();
        },
        toggleSubTerm(term, subTerm) {
            if (subTerm.selected && !subTerm.is_radio) {
                subTerm.selected = false;

                term.sub_terms.forEach((item) => {
                    if (item.depends_from === subTerm.slug) {
                        item.selected = false;
                    }
                })
            } else {
                if ((this.selectedPlan.name === 'gold') || (subTerm.score <= this.availablePoints) || subTerm.slug === this.termToSuggest) {
                    if (!subTerm.depends_from) {
                        subTerm.selected = true;
                    } else {
                        const dependTerm = _.find(term.sub_terms, {slug: subTerm.depends_from});
                        subTerm.selected = dependTerm.selected;
                    }

                    if (subTerm.is_radio) {
                        term.sub_terms.forEach((item) => {
                            if (item.is_radio) {
                                item.selected = item.slug === subTerm.slug;
                            }
                        })
                    }
                } else {
                    this.$refs.upgradePlanModal.open(() => {
                        this.upgradePlan();
                    });
                }
            }

            this.updateTermIds();
        },
        fillScoresChartData() {
            this.scoresChartData = {
                labels: [
                    __('forms.options.tax_optimization'),
                    __('forms.options.finance'),
                    __('forms.options.strategy'),
                    __('forms.options.stability'),
                    __('forms.options.risk_minimization'),
                ],
                datasets: [
                    {
                        backgroundColor: 'rgba(38, 60, 97, 0.4)',
                        borderColor: 'rgb(38, 60, 97)',
                        data: Object.values(this.scores),
                    },
                ],
            };
        },
    },
};
